export enum ProfileSelectorFieldTypeEnum {
  StandardField = 0,
  AffCode = 1,
  AffCodeType = 2,
  CustomField = 3,
}
